function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.76 82.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.15,1.21c-1.46,1.78-1.99,8.21-2.79,33.75-.55,17.59-1.1,23.81-2.55,28.5-1.96,6.35-2.33,10.29-1.12,12.09,1.91,2.83,9.77,7.41,12.71,7.41,4.61,0,13.92-6.68,14.34-10.3.18-1.51-1.29-7.41-3.26-13.12-2.91-8.42-3.76-12.75-4.54-22.95-.88-11.55-4.72-30.36-7.11-34.82-1.12-2.09-4.18-2.39-5.68-.56",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24,14.96c1.4,5.78,2.85,15,3.21,20.5s1,11.58,1.41,13.52l.75,3.52-6.59-.07-6.59-.07.08-8.95c.1-11.28,1.39-36.17,2.04-39.35.89-4.31,2.96-.32,5.69,10.91",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.93,55.34c1.94.44,2.99,1.86,4.69,6.34,2.85,7.52,3.51,10.54,2.57,11.81-1.5,2.04-9.69,7.47-11.26,7.47-2.16,0-10.92-5.62-11.62-7.46-.6-1.56,3.23-15.21,4.83-17.23,1.02-1.29,4.41-2.17,6.8-1.75.82.14,2.63.51,4,.83",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.5e077000de4242dc9d308a6319960e08.svg";
export { ForwardRef as ReactComponent };